module.exports = __webpack_public_path__ + "img/24.bfd4d57c.png";